import ValidatableTestCase from "../../../../models/ValidatableTestCase.model";
import ProductSide from "../../../../models/ProducSide.model";
import TestCaseRating from "../../../../models/TestCaseRating.model";
import formatIdentifierAsString from "../../../../../../functions/formatIdentifierAsString.function";
import { RowData } from "../interfaces/RowData";
import TestSeriesDTO from "../../../../../../api/models/TestSeriesDTO";

export default function dataToRows(data: ValidatableTestCase[], testSeriesObject: TestSeriesDTO): RowData[] {
  const newRows = [] as RowData[];
  data.forEach((testCase) => {
    const {
      buildingActionFlowId,
      conditionId,
      firstSubstrateActionFlowId,
      hasNotes,
      hasAttachments,
      productSampleActionFlowId,
      secondSubstrateActionFlowId,
      treatmentActionFlowId,
    } = testCase;

    const firstSubstrateActionFlow = (testSeriesObject.substrateSections[0]?.substrateActionFlows || []).filter(
      (actionFlow) => actionFlow.actionFlow?.id === firstSubstrateActionFlowId,
    );
    const firstSubstrateSecondaryChips =
      firstSubstrateActionFlow.length === 1 ? firstSubstrateActionFlow[0].actionFlow?.actionValues : [];

    const secondSubstrateActionFlow =
      testSeriesObject.substrateSections.length > 1
        ? testSeriesObject.substrateSections[1].substrateActionFlows.filter(
            (actionFlow) => actionFlow.actionFlow?.id === secondSubstrateActionFlowId,
          )
        : [];
    const secondSubstrateSecondaryChips =
      secondSubstrateActionFlow.length === 1 ? secondSubstrateActionFlow[0].actionFlow?.actionValues : [];

    const productSampleActionFlow = testSeriesObject.productSection.productActionFlows.filter(
      (actionFlow) => actionFlow.actionFlow?.id === productSampleActionFlowId,
    );
    const productSampleSecondaryChips =
      productSampleActionFlow.length === 1 ? productSampleActionFlow[0].actionFlow?.actionValues : [];

    const buildingActionActionFlow = testSeriesObject.specimenSection.buildingActions.filter(
      (actionFlow) => actionFlow.id === buildingActionFlowId,
    );
    const buildingActionSecondaryChips =
      buildingActionActionFlow.length === 1 ? buildingActionActionFlow[0].actionValues : [];

    const specimenTreatmentActionFlow = testSeriesObject.specimenSection.treatments.filter(
      (actionFlow) => actionFlow.id === treatmentActionFlowId,
    );
    const specimenTreatmentSecondaryChips =
      specimenTreatmentActionFlow.length === 1 ? specimenTreatmentActionFlow[0].actionValues : [];

    const measurementCondition = testSeriesObject.conditionSection.conditions.filter(
      (actionFlow) => actionFlow.id === conditionId,
    );
    const conditionSecondaryChips = measurementCondition.length === 1 ? measurementCondition[0].parameterValues : [];

    newRows.push(
      createRowData(
        testCase.id,
        testCase.indexNumber,
        testCase.productSampleActionFlowName,
        testCase.sideOfProduct,
        testCase.progress,
        testCase.rating,
        testCase.firstSubstrateActionFlowName,
        testCase.secondSubstrateActionFlowName,
        (!testCase.hasOnlyGlobalBuildingActions || undefined) && testCase.buildingActionFlowName,
        (!testCase.hasOnlyGlobalTreatments || undefined) && testCase.treatmentActionFlowName,
        (!testCase.hasOnlyGlobalConditions || undefined) && testCase.conditionName,
        !testCase.excluded,
        testCase.invalid,
        productSampleSecondaryChips,
        buildingActionSecondaryChips,
        specimenTreatmentSecondaryChips,
        conditionSecondaryChips,
        firstSubstrateSecondaryChips,
        secondSubstrateSecondaryChips,
        hasNotes,
        hasAttachments,
      ),
    );
  });
  return newRows;
}

function createRowData(
  id: number,
  indexNumber: number,
  product: string,
  sideOfProduct: ProductSide,
  progress: {
    completed: number;
    total: number;
  },
  rating: TestCaseRating,
  firstSubstrate?: string,
  secondSubstrate?: string,
  buildingAction?: string,
  treatment?: string,
  condition?: string,
  included?: boolean,
  invalid?: boolean,
  productSampleSecondaryChips?: any[],
  buildingActionSecondaryChips?: any[],
  specimenTreatmentSecondaryChips?: any[],
  conditionSecondaryChips?: any[],
  firstSubstrateSecondaryChips?: any[],
  secondSubstrateSecondaryChips?: any[],
  hasNotes?: boolean,
  hasAttachments?: boolean,
): RowData {
  return {
    id,
    indexNumber,
    product,
    productSubHeader: `Side: ${formatIdentifierAsString(sideOfProduct)}`,
    progress,
    rating,
    firstSubstrate,
    secondSubstrate,
    buildingAction,
    treatment,
    condition,
    included,
    invalid,
    productSampleSecondaryChips,
    buildingActionSecondaryChips,
    specimenTreatmentSecondaryChips,
    conditionSecondaryChips,
    firstSubstrateSecondaryChips,
    secondSubstrateSecondaryChips,
    hasNotes,
    hasAttachments,
  };
}
